//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () { return { account: {}, list: [], loading: true } },
  created () {
    this.$ajax.get(newApi.pointsAccount).then(res => { this.account = res || {} }).catch(() => {})
    this.$ajax.get(newApi.pointsLog + '?page_size=50').then(res => {
      this.list = (res && res.list) || []
    }).catch(() => {}).finally(() => { this.loading = false })
  },
  methods: {
    formatTime (t) {
      if (!t) return ''
      return String(t).substring(0, 16)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/points/log.vue